export const GET_LAB_SOCKET_URL = (token: string, labID: number) => {
    let proto = 'ws';
    if (location.protocol.toString().indexOf('https')==0) {
        proto = 'wss'
    }
    return proto +`://${location.host}/ws?token=${token}&labID=${labID}`
}